/* eslint-disable react/no-array-index-key */
import React from 'react';
import cx from 'clsx';

import { ProductBadge } from '~/components';
import type { OAISchema } from '~/types/openapi';

import { SafeDeliveryWithTextIcon, Text택배배송Icon } from '~/assets/icons';

type Props = {
  flags?: OAISchema['MarketSelectProductResponseV2']['deliveryFlags'];
  isFreeShipping?: boolean;
  is3x2?: boolean;
  className?: string;
};

function DeliveryFlag({
  flags = [],
  isFreeShipping,
  is3x2 = false,
  className,
}: Props) {
  const hasFlags = flags && flags.length > 0;
  if (!hasFlags && !isFreeShipping) return <></>;

  return (
    <div
      className={cx(
        'mt-4 flex gap-4',
        is3x2 ? 'flex-col items-start' : 'items-center h-24',
        className,
      )}
    >
      {flags?.map((flag) => {
        switch (flag) {
          case 'COURIER':
            return <Text택배배송Icon key={flag} />;
          case 'SAFE_DELIVERY':
            return <SafeDeliveryWithTextIcon key={flag} />;
          case 'NONE':
          default:
            return null;
        }
      })}
      {isFreeShipping && <ProductBadge type="freeDelivery" />}
    </div>
  );
}

export default DeliveryFlag;
